<template>
  <div class="pd-2 mr-1 ml-1 noselect sidebar-button" :class="{active: active}" :style="[active?{backgroundColor: fillColor, borderColor: fillColor}:{color: color, borderColor: borderColor}]" @click="buttonClicked($event.target.id)"><span @click="buttonClicked($event.target.parentElement.id)">{{caption}}</span></div>
</template>

<script>
export default {
  components: {
  },
  props: {
    caption: String,
    color: String,
    borderColor: String,
    fillColor: String,
    active: Boolean
  },
  data: () => ({
  }),
  created () {
  },
  methods: {
    buttonClicked: function (id) {
      if (!id || id.length === 0) {
        return
      }
      this.$emit('clicked', id, !this.active)
    }
  }
}
</script>

<style>
.sidebar-button {
  transition: all 0.2s;
}
.sidebar-button.active {
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarButton.vue